<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-3 col-lg-3 col-md-2 "></div>
            <div class="col-9 col-lg-9 col-md-10 ">
                <div class="header-block">
                    <h2>Переваги Anima</h2>
                    <p>
                        Anima – це ваш особистий AI-асистент для психічного добробуту, створений на основі науки та керований емпатією.
                        Ми базуємося на чотирьох ключових принципах: передова нейронаука, технологія відстеження погляду, повна конфіденційність і об'єктивне розуміння роботи вашої психіки.
                    </p>
                </div>
            </div>
        </div>

        <app-about-us-ai-item [item]="item" *ngFor="let item of data"></app-about-us-ai-item>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
